var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4094 12C13.4094 15.3133 10.6319 18 7.204 18C6.39036 18.001 5.58448 17.8467 4.83236 17.5457C4.08024 17.2448 3.39662 16.8031 2.82053 16.246C2.24443 15.6888 1.78715 15.0271 1.47478 14.2986C1.16241 13.57 1.00108 12.789 1 12C1 8.68534 3.7775 6.00001 7.204 6.00001C8.01775 5.99878 8.82379 6.15301 9.57606 6.45389C10.3283 6.75477 11.0121 7.19641 11.5884 7.75358C12.1646 8.31075 12.622 8.97253 12.9345 9.70114C13.2469 10.4297 13.4083 11.2109 13.4094 12ZM20.2156 12C20.2156 15.12 18.8269 17.648 17.1136 17.648C15.4004 17.648 14.0116 15.1187 14.0116 12C14.0116 8.88 15.4004 6.35201 17.1136 6.35201C18.8269 6.35201 20.2156 8.88134 20.2156 12ZM23 12C23 14.7947 22.5119 17.06 21.9083 17.06C21.306 17.06 20.8179 14.7933 20.8179 12C20.8179 9.20534 21.306 6.94001 21.9096 6.94001C22.5119 6.94001 23 9.20534 23 12Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedium);
export default __webpack_public_path__ + "static/media/icon-medium.70d13adf20b0263e271dfd5f304580d0.svg";
export { ForwardRef as ReactComponent };